import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text } from '@maui/elements'
import isEmpty from 'lodash/isEmpty'

import { v2StringMap, v3StringMap } from './colorMaps'

export const CVSSSummary = ({ vulnScores }) => {
  const { 'v2.0': v2 = {}, 'v3.1': v31 = {} } = vulnScores || {}
  const v2BaseColor = v2StringMap(v2.base_score)?.color
  const v2BaseLabel = v2StringMap(v2.base_score)?.label
  const v2TemporalColor = v2StringMap(v2.temporal_score)?.color
  const v2TemporalLabel = v2StringMap(v2.temporal_score)?.label
  const v3BaseColor = v3StringMap(v31.base_score)?.color
  const v3BaseLabel = v3StringMap(v31.base_score)?.label
  const v3TemporalColor = v3StringMap(v31.temporal_score)?.color
  const v3TemporalLabel = v3StringMap(v31.temporal_score)?.label

  return (
    <Box display="flex" flexWrap="wrap" gap="8">
      {!isEmpty(vulnScores['v3.1']) && (
        <Box flexBasis="25%">
          <Text color="colorTextDeemphasis" mb="spaceGapMedium">CVSS v3.1 Base</Text>
          <Text fontWeight="fontWeightBold" color={v3BaseColor}>
            {v31.base_score} ({v3BaseLabel})
          </Text>
        </Box>
      )}
      {!isEmpty(vulnScores['v3.1']) && (
        <Box flexBasis="25%">
          <Text color="colorTextDeemphasis" mb="spaceGapMedium">CVSS v3.1 Temporal</Text>
          <Text fontWeight="fontWeightBold" color={v3TemporalColor}>
            {v31.temporal_score} ({v3TemporalLabel})
          </Text>
        </Box>
      )}
      {!isEmpty(vulnScores['v2.0']) && (
        <Box flexBasis="25%">
          <Text color="colorTextDeemphasis" mb="spaceGapMedium">CVSS v2 Base</Text>
          <Text fontWeight="fontWeightBold" color={v2BaseColor}>
            {v2.base_score} ({v2BaseLabel})
          </Text>
        </Box>
      )}
      {!isEmpty(vulnScores['v2.0']) && (
        <Box flexBasis="25%">
          <Text color="colorTextDeemphasis" mb="spaceGapMedium">CVSS v2 Temporal</Text>
          <Text fontWeight="fontWeightBold" color={v2TemporalColor}>
            {v2.temporal_score} ({v2TemporalLabel})
          </Text>
        </Box>
      )}
    </Box>
  )
}

CVSSSummary.propTypes = {
  vulnScores: PropTypes.shape({
    'v2.0': PropTypes.shape({
      base_score: PropTypes.number,
      temporal_score: PropTypes.number
    }),
    'v3.1': PropTypes.shape({
      base_score: PropTypes.number,
      temporal_score: PropTypes.number
    })
  })
}
